import React, {useEffect, useState} from 'react';
import IconComponent from '../icons';
import styles from './categories.module.scss'

const Categories = (props)=> {
  const {categories, showText, hideText, ourExpertiseText, toggleAll, setToggleAll, hightlightCategories,index,expertiesExpanded,setDefaultHideExpertiesExpantion} = props;
  const [toggle, setToggle] = useState(false);
  
  const handleToggleChange = () => {
    setToggle(!toggle);
    setToggleAll(false)
    setDefaultHideExpertiesExpantion(index);
  };
  useEffect(()=>{
    toggleAll ? setToggle(true) : setToggle(false);
  }, [toggleAll])


  const handleClick=(url)=>{
    return window.location = url;
  }

  const handleFooter =()=>{
    if(categories && categories.length){
      return(
        <span onClick={handleToggleChange} className="px-4 h-[37px] flex items-center justify-center border-t border-solid border-ek-grey-300 text-[14px] font-normal leading-[21px] text-ek-grey-500 cursor-pointer">
          {expertiesExpanded ? hideText : showText}
          <IconComponent icon='chevron-slim' className={`chevron-slim mx-3 relative text-ek-red ${expertiesExpanded ? '-rotate-90': 'rotate-90'}`} />
        </span>
      )
    }
  }
  const renderCategories = ()=>{
    if(categories && categories.length){
      return (
        <section className={`p-5 pt-[5px] ${expertiesExpanded ? '' : 'hidden'}`}>
          <div className="pb-3 lg:pb-4 text-base font-normal tracking-[0.64px]">{ourExpertiseText}</div>
          <div className="grid grid-cols lg:grid-cols-3 gap-4">
            {categories.map((category, index)=>{
              return (
                <div onClick={()=>{handleClick(category.linkHref)}} key={`category-${index}`} id={`category-${index}`} className={`h-full p-4 rounded-lg border border-ek-grey-300 cursor-pointer ${hightlightCategories(category.title) ? "" : "opacity-30"} `}>
                  <h5 className="pb-2 text-base lg:text-lg font-bold leading-[22.4px] lg:leading-[27px] text-black tracking-[0.36px]">{category.title}</h5>
                  <div className={`text-sm font-normal text-ek-grey-500 tracking-[0.56px] ${styles.desc}`} ><p>{category.description}</p></div>
                </div>
              )
            })
            }
          </div>
      </section>
      )
    }
  }

  return (
    <>
      {renderCategories()}
      {handleFooter()}
    </>
  )
}

export default Categories;
